const styles = ({ spacing, palette }) => ({
  nameField: {
    minHeight: spacing(10),
    input: {
      '&:-webkit-autofill': {
        borderRadius: 'inherit',
      },
    },
  },
  addressField: {
    minHeight: spacing(8),
    input: {
      '&:-webkit-autofill': {
        borderRadius: 'inherit',
      },
    },
  },
  phoneField: {
    input: {
      '&:-webkit-autofill': {
        borderRadius: 'inherit',
      },
    },
  },
  registrationDialogContent: {
    padding: spacing(4),
  },
  btnDialogAction: {
    textTransform: 'inherit',
  },
  checkBoxConsent1: {
    alignSelf: 'flex-start',
    paddingTop: spacing(0.25),
    paddingRight: spacing(1),
  },
  selectStates: {
    backgroundColor: palette.background.default,
  },
  ssnField: {
    backgroundColor: palette.background.default,
  },
});

export default styles;
